import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, takeUntil, tap } from 'rxjs';
import { TagManagerActions } from './tag-manager.actions';
import { TagManagerService } from './tag-manager.service';

@Injectable()
export class TagManagerEffects {
  connectDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagManagerActions.connectTags),
      switchMap(({ payload }) =>
        this.tagManagerService
          .subscribe({ ...payload })
          .pipe(
            takeUntil(
              this.actions$.pipe(ofType(TagManagerActions.disconnectTags))
            )
          )
      ),
      map(({ op, res, sts, id }: any) => {
        switch (op) {
          case 'query':
            return res
              ? TagManagerActions.queryTagsSuccess({ tags: res })
              : TagManagerActions.queryTagsFailure({ error: sts });
          case 'ins':
            return res
              ? TagManagerActions.createTagSuccess({ tag: res })
              : TagManagerActions.createTagFailure({ error: sts });
          case 'del':
            return res
              ? TagManagerActions.deleteTagSuccess({ tag: res })
              : TagManagerActions.deleteTagFailure({ error: sts });
          case 'upd':
            return res
              ? TagManagerActions.updateTagSuccess({ tag: res })
              : TagManagerActions.updateTagFailure({ error: sts });
          default:
            return {
              type: '[Tags Manager] Unknown operation',
            };
        }
      })
    )
  );

  createTag$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TagManagerActions.createTag),
        tap(({ tag }) => {
          this.tagManagerService.createTag(tag);
        })
      ),
    { dispatch: false }
  );

  deleteTag$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TagManagerActions.deleteTag),
        tap(({ tag }) => {
          this.tagManagerService.deleteTag(tag);
        })
      ),
    { dispatch: false }
  );

  updateTag$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TagManagerActions.updateTag),
        tap(({ tag }) => {
          this.tagManagerService.updateTag(tag);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private tagManagerService: TagManagerService
  ) {}
}
